// import DonbarFooter from '@Components/DonbarFooter';
import useSelectedElement from '@hooks/useSelectedElement';
import { Body, Preview } from '@react-email/components';
import i18next from 'i18next';
import { merge } from 'lodash';

const body = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const { setSelectedElement } = useSelectedElement();

        return (
            <div
                onMouseDown={e => {
                    e.preventDefault();
                    setSelectedElement(null);
                }}
                {...attributes}
                dir={i18next.dir(element.attributes.lang)}
                {...merge(
                    { style: { overflow: 'hidden', cursor: 'default' } },
                    element.attributes,
                )}
            >
                {children}
            </div>
        );
    },
    PreviewElement: ({ node, attributes, children }) => {
        return (
            <Body {...attributes} dir={i18next.dir(attributes.lang)}>
                {'{{preview_text}}'}
                {children}
                {/* <DonbarFooter /> */}
                {'{{email_footer}}'}
            </Body>
        );
    },
};

export default body;
